var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTotalCount = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C7DDE0",
  d: "M24 3c11.58 0 21 9.42 21 21s-9.42 21-21 21S3 35.58 3 24 12.42 3 24 3m0-3C10.74 0 0 10.74 0 24s10.74 24 24 24 24-10.74 24-24S37.26 0 24 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C7DDE0",
  d: "M30.701 21.84h-13.42c-.82 0-1.5-.68-1.5-1.5s.68-1.5 1.5-1.5h13.42c.82 0 1.5.68 1.5 1.5s-.68 1.5-1.5 1.5M30.701 29.16h-13.42c-.82 0-1.5-.68-1.5-1.5s.68-1.5 1.5-1.5h13.42c.82 0 1.5.68 1.5 1.5s-.68 1.5-1.5 1.5"
})));
export default SvgTotalCount;